import React from "react";
import twitter from "../images/new/footer/twitter.png";

function Twitter() {

    return (

        <section id="twitter-sec">
        <div className="wrapper">

        <div className="twitter">
      <h3>Twitter community coming soon</h3>
{/* 
       <h3>Add your twitter handle to be part of the community</h3>
       <p>Get five prosper points to connect twitter <img className="twitter-community-icon" src={twitter} alt="Twitter" /> account</p>

     <div className="twitter-feeds">

     </div> */}




        </div>

        </div>
    </section>

        );
    }
        export default Twitter;